import React from "react";

const NotFound = () => {
  return (
    <>
      <div className="not-found-content m-auto py-5 text-center">
        <img
          src="/images/error.png"
          className="mb-4"
          alt="error"
          width={400}
          height={400}
        />

        <h3 className="fs-24 mb-3">
          به نظر می‌رسد این صفحه را پیدا نکردیم، لطفاً بعداً دوباره امتحان کنید.
        </h3>

        <p className="mb-4">
          اما نگران نباشید! تیم ما در تمام مدت انتظار شما، به دنبال خطا می‌گردد.
        </p>

        <a href="/" className="btn btn-primary py-2 px-4 fs-16 fw-medium">
          <span className="d-inline-block py-1">برگشت به خانه</span>
        </a>
      </div>
    </>
  );
};

export default NotFound;
